(function ($) {

'use strict';

	/**
	 * Set the accesskey and extend the title " [Alt+<key>]".
	 * If the key is not passed, the current key is used
	 * @param {string} key
	 * @returns {common_L3.$.fn}
	 */
	$.fn.setAccessKey = function (key) {
		if ($(this).length < 1) {
			return this;
		}

		if (!key) {
			key = $(this).attr('accesskey');
		}
		if (key) {
			var title = $(this).attr('title');
			var keyPrefix = (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ? 'Shift+' : '');
			var accessKeyTitle = ' [' + keyPrefix + 'Alt+' + key + ']';

			$(this).attr('accesskey', key);

			if (typeof title === 'undefined') {
				title = '';
			} else if (title.indexOf(accessKeyTitle) !== -1) {
				accessKeyTitle = '';
			}
			$(this).attr('title', title + accessKeyTitle);
		}

		return this;
	};

}(jQuery));